import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom'
import { Layout } from 'antd';
import SiteHeader from '../components/header';
import SettingsMenu from '../components/site/settings/SettingsMenu';
import Can from '../services/permisions/Can'

const { Content } = Layout;

/* Main Layout */
const SettingsLayout = ({ children, ...rest }) => {
  return (
    <Layout>
      <SiteHeader isSettingsHeader={true}></SiteHeader>
      <Layout>
        <Layout>
          <Content>
            <div className="settings-block tb--pb-8">
              <SettingsMenu />
              <div className="settings--section-content">
                {children}
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

/*
  Private route wrapper for React Router v6
 */

export const SettingsLayoutRoute = ({ component: Component, permissions, ...rest }) => {
  const params = useParams();
  const permissionName = typeof permissions?.name === 'object' ? permissions?.name[params?.type] : permissions?.name;
  
  const content = (
    <SettingsLayout>
      <Suspense fallback={<></>}>
        <Component {...rest} />
      </Suspense>
    </SettingsLayout>
  );

  if (!permissions) {
    return content;
  }

  return (
    <Can I={permissions.type} a={permissionName} withRedirect={true}>
      {content}
    </Can>
  );
};